import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

const DEFAULT_CONFIRM_MESSAGE = 'This Action will assign all future trips assigned to excluded providers to None.';

@Injectable()
export class DualListBoxService {
  private confirmMessageSubject = new BehaviorSubject<string>(DEFAULT_CONFIRM_MESSAGE);
  confirmMessage$: Observable<string> = this.confirmMessageSubject.asObservable();

  private leftSelectionChangedSubject = new Subject<number[]>();
  leftSelectionChanged$: Observable<number[]> = this.leftSelectionChangedSubject.asObservable();

  getConfirmMessage(): string {
    return this.confirmMessageSubject.getValue();
  }

  setConfirmMessage(message: string): void {
    this.confirmMessageSubject.next(message);
  }

  resetConfirmMessage(): void {
    this.confirmMessageSubject.next(DEFAULT_CONFIRM_MESSAGE);
  }

  emitLeftSelectionChanged(ids: number[]): void {
    this.leftSelectionChangedSubject.next(ids);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/dual-list-box/dual-list-box.service.ts